export const Category = {
  "1": "Граждане, ищущие работу (или трудоустроенные)",
  "12": "Граждане, находящиеся в отпуске по уходу за ребенком до 3 лет",
  "4": "Женщины, имеющие детей дошкольного возраста, не состоящие в трудовых отношениях",
  "2": "Лица в возрасте 50-ти лет и старше",
  "7": "Граждане до 35 лет включительно, не занятые по истечении 4 месяцев с даты выдачи им документа об образовании и о квалификации",
  "6": "Граждане до 35 лет включительно, не имеющие среднего профессионального и высшего образования",
  "11": "Инвалиды",
  "8": "Безработные граждане, зарегистрированные в органах службы занятости",
  "10": "Лица, принимавшие участие в боевых действиях",
  "9": "Ветераны боевых действий принимавшие участие в СВО",
  "13": "Члены семей военных, погибших при исполнении в ходе специальной военной операции (боевых действий)",
  "5": "Граждане до 35 лет включительно, не занятые по истечении 4 месяцев с даты окончания военной службы по призыву",
};

export const EmploymentFormat = {
  "2": "Официально трудоустроен",
  "1": "Не трудоустроен официально",
};

export const Education = {
  "1": "Среднее (школьное)",
  "2": "Получаю среднее профессиональное",
  "3": "Среднее профессиональное (колледж, техникум и т.д.)",
  "4": "Получаю высшее образование",
  "5": "Высшее (оконченное)",
};